import type { MenuDataItem } from '@ant-design/pro-components';

const filterAccessibleMenuData = (
  menuData: MenuDataItem[],
  visibleParentKeys?: ReadonlySet<string>,
): MenuDataItem[] =>
  menuData.flatMap((item) => {
    if (item.unaccessible || item.redirect) return [];
    if (
      item.hideInMenu &&
      !item.parentKeys?.some((key) => visibleParentKeys?.has(key))
    )
      return [];
    if (item.children?.length) {
      const children = filterAccessibleMenuData(
        item.children,
        visibleParentKeys,
      );
      return children.length ? [{ ...item, children }] : [];
    }
    return item.path ? [item] : [];
  });

export const getAccessibleMenuData = (
  menuData: MenuDataItem[],
  keepLinkedHiddenRoutes = false,
): MenuDataItem[] => {
  const visible = filterAccessibleMenuData(menuData);
  if (!keepLinkedHiddenRoutes) return visible;
  const parentKeys = new Set<string>();
  const collect = (items: MenuDataItem[]) => {
    for (const item of items) {
      if (item.key) parentKeys.add(item.key);
      if (item.path) parentKeys.add(item.path);
      collect(item.children ?? []);
    }
  };
  collect(visible);
  // ProLayout按完整路由匹配parentKeys；仍由hideInMenu隐藏入口，且只能关联有权限的可见菜单。
  return filterAccessibleMenuData(menuData, parentKeys);
};

export const findFirstAccessibleMenuPath = (
  menuData: MenuDataItem[],
): string | undefined => {
  for (const item of getAccessibleMenuData(menuData)) {
    const childPath = findFirstAccessibleMenuPath(item.children ?? []);
    if (childPath) return childPath;
    if (!item.children?.length && item.path?.startsWith('/')) return item.path;
  }
  return undefined;
};
